<template>
	<div id="center">
		<div class="up">
			<div class="bg-color-black item" v-for="item in titleItem" :key="item.title">
				<p class="ml-3 colorBlue fw-b fs-xl" style="text-align: center;">{{ item.title }}</p>
				<div class="bigtext">{{item.number.number}}</div>
				<div class="new-add">
					<font><span style="color: yellow;">昨日：</span>{{item.zrnum}}</font>
					<font><span style="color: yellow;">今日：</span>{{item.jrnum}}</font>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import request from '@/utils/request';
export default {
	data() {
		return {
			titleItem: [
				{
					title: '纳入管理人数',
					number: {
						number: '',
						toFixed: 0,
						textAlign: 'center',
						content: '{nt}',
						style: {
							fontSize: 28
						}
					},
					zrnum:'100',
					jrnum:'20',
					bfb:'↑62.6%',
					type:1
				},
				{
					title: '评估干预人数',
					number: {
						number: '',
						toFixed:0,
						textAlign: 'center',
						content: '{nt}',
						style: {
							fontSize: 28
						}
					},
					zrnum:'100',
					jrnum:'20',
					bfb:'↓20%',
					type:2
				},
				{
					title: '基层首诊人数',
					number: {
						number: '',
						toFixed: 0,
						textAlign: 'center',
						content: '{nt}',
						style: {
							fontSize: 28
						}
					},
					zrnum:'100',
					jrnum:'20',
					bfb:'0%',
					type:0
				},
				{
					title: '上级转诊人数',
					number: {
						number: '',
						toFixed: 0,
						textAlign: 'center',
						content: '{nt}',
						style: {
							fontSize: 28
						}
					},
					zrnum:'100',
					jrnum:'20',
					bfb:'↑36.01%',
					type:1
				},
				{
					title: '随访服务人数',
					number: {
						number: '',
						toFixed: 0,
						textAlign: 'center',
						content: '{nt}',
						style: {
							fontSize: 28
						}
					},
					zrnum:'100',
					jrnum:'20',
					bfb:'↓21.71%',
					type:2
				},
				{
					title: '档案建档人数',
					number: {
						number: '',
						toFixed: 0,
						textAlign: 'center',
						content: '{nt}',
						style: {
							fontSize: 28
						}
					},
					zrnum:'100',
					jrnum:'20',
					bfb:'↑17.13%',
					type:1
				}
			],
		};
	},
	components: {
	},
	mounted() {
		let area=this.$route.query.area;
		let code=this.$route.query.code;
		let level=this.$route.query.level;
		this.getdata(area,code,level)
	},
	methods: {
		getdata(area,code,level){
			var data={}
			if(level=='2'){
				data={area:area}
			}else{
				data={code:code}
			}
			request({
				url: this.$root.api + `/api/dbz/daping/dpsltj`,
				method: 'get',
				data:data
			}).then(res => {
				// res.data=JSON.parse("{\"id\":null,\"tjsj\":null,\"tjtype\":null,\"scrqrs\":970287,\"zrscrqrs\":522,\"jrscrqrs\":652,\"pgrs\":67635,\"zrpgrs\":365,\"jrpgrs\":396,\"jcszrs\":1156,\"zrjcszrs\":22,\"jrjcszrs\":16,\"szrs\":125,\"zrszrs\":8,\"jrszrs\":6,\"xzrs\":67635,\"sffwrs\":67635,\"zrsffwrs\":552,\"jrsffwrs\":689,\"jdrs\":603555,\"zrjdrs\":3555,\"jrjdrs\":2544,\"createTime\":null,\"updateTime\":null}")
				var titleItem = this.titleItem
				titleItem[0].number.number = res.data.scrqrs
				titleItem[0].zrnum = res.data.zrscrqrs
				titleItem[0].jrnum = res.data.jrscrqrs

				titleItem[1].number.number = res.data.pgrs
				titleItem[1].zrnum = res.data.zrpgrs
				titleItem[1].jrnum = res.data.jrpgrs

				titleItem[2].number.number = res.data.jcszrs
				titleItem[2].zrnum = res.data.zrjcszrs
				titleItem[2].jrnum = res.data.jrjcszrs

				titleItem[3].number.number = res.data.szrs
				titleItem[3].zrnum = res.data.zrszrs
				titleItem[3].jrnum = res.data.jrszrs

				titleItem[4].number.number = res.data.sffwrs
				titleItem[4].zrnum = res.data.zrsffwrs
				titleItem[4].jrnum = res.data.jrsffwrs

				titleItem[5].number.number = res.data.jdrs
				titleItem[5].zrnum = res.data.zrjdrs
				titleItem[5].jrnum = res.data.jrjdrs
				this.titleItem = titleItem
			});
		}
	}
};
</script>

<style lang="scss" scoped>
#center {
	display: flex;
	flex-direction: column;
	.up {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-around;
		padding-top: 5px;
		.item {
			border-radius: 6px;
			padding-top: 8px;
			margin-top: 8px;
			margin-left: 5px;
			margin-right: 5px;
			width:calc(50% - 10px);
			height: 120px;
			.dv-dig-flop {
				width: 200px;
				margin: 0 auto;
				height: 40px;
			}
			p {
				font-size:18px;
				margin-top:10px;
				margin-bottom:5px
			}
			.bigtext {
				color: #67e0e3;
				text-align: center;
				font-size: 28px;
				font-weight: bold;
				line-height: 40px;
			}
			.new-add {
				width: 100%;
				text-align: center;
				font-size: 14px;
				font {
					margin-left: 10px;
					margin-right: 10px;
					color: #67e0e3;
				}
				.itemgreen {
					color: #1BD175;
				}
				.itemblue {
					color: #03a9f4;
				}
				.itemred {
					color: red;
				}
			}
		}
	}
}
</style>
